import { Component, OnInit, Injector, model, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Identity, VerifyIdentity } from '../models/customer.model';
import { FormVerifyCustomerService } from '../services/form-verify-customer.service';
import { ResponseCodeVerifyCustomer, Customer } from '../models/customer.model';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { lineSelector } from '../statemanagement/line.action';
import { SetIdentityAction, IdentityAction } from '../statemanagement/action/identity.action';
import { BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../services/loader.service';
import { SetCustomerAction } from '../statemanagement/action/customer.action';
import { ResponseStateRegistration, ResponseStateLineID, VerifyLineID } from '../models/verify.model';
import { ModalService } from 'src/app/shared/service/modal/modal.service';
import { LineModalTemplateComponent } from 'src/app/shared/service/modal/components/line-modal-template/line-modal-template.component';
import { LineModalTemplateService } from 'src/app/shared/service/modal/components/line-modal-template/line-modal-template.service';
import { encryptData, decryptData } from '../../../core/utilities';
import { BaseComponents } from 'src/app/base.component';
import { ReferenceService } from 'src/app/services/reference.service';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';

import liff from '@line/liff';
@Component({
    selector: 'app-mobile-verify',
    templateUrl: './mobile-verify.component.html',
    styleUrls: ['./mobile-verify.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MobileVerifyComponent extends BaseComponents implements OnInit {

  regTel = /^0[1-9][0-9]{7,8}$/;
  type: string;
  //model:Identity;
  model = model<any>({
    form: {
      mobile: { value: '', text: '' },
    }
  });
  inValidPhoneCount = 0;
  invalidInformation: boolean;
  $IdentityStateAction: BehaviorSubject<IdentityAction> = new BehaviorSubject(null);
  log_session_text: string = "mobile-verify";
  referenceUUID: string | null = null;

  constructor(
    protected injectorObj: Injector,
    private verifyService: FormVerifyCustomerService,
    private lineActionService: LineStateActionService,
    private router: Router,
    private lineStateAction: LineStateActionService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private verifyCustomerService: FormVerifyCustomerService,
    private modalService: ModalService,
    private lineModalService: LineModalTemplateService,
    private referenceService:ReferenceService,
    private getMaskingService : GetMaskingService,
  ) {
    super(injectorObj);
   }

  ngOnInit() {
    const funcName = 'ngOnInit';
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.log_session_text = `mobile-verify referenceUUID:[${this.referenceUUID}]`;
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    // this.lineActionService.stateAction(lineSelector.SELECTOR_IDENTITY);
    // this.$IdentityStateAction = this.lineActionService.$stateAction;
    this.$IdentityStateAction = this.lineActionService.sinkIdentity;
    this.lineActionService.observableIdentity.subscribe(
      result => {
        console.log('result of observable identity', result);
      }
    )
    this.lineActionService.observableChannel.subscribe(
      result => {
        console.log('result of observable channel', result);
      }
    )
    this.lineActionService.observableCustomer.subscribe(
      result => {
        console.log('result of observable customer', result);
      }
    )

    try {
      this.route.queryParams
        .subscribe(async (params) => {
          console.log(params);
          this.type = params.type;
        });


    } catch (err) {
      console.log(err);
    }

  }

  addClass(f: NgForm, field: string, type?: string, valueActive = '') {
    const iClass = [];
    if (f.form.get(field) && type !== 'msg') {
      if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        iClass.push('uk-form-danger');
      } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        if (valueActive === '') {
          iClass.push('uk-form-success');
        } else if (f.form.get(field).value === valueActive) {
          iClass.push('uk-form-success');
        }
      }
    } else if (f.form.get(field) && type === 'msg') {
      if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        iClass.push('uk-animation-fade');
      } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        iClass.push('uk-animation-reverse');
      }
    }

    return iClass;
  }

  onKeyPress(params: any) {
    if (params.key === 'Backspace' || params.key === '.') {
      return true;
    } else if (!this.isKeyPressedNumeric(params)) {
      return false;
    }
  }

  private isKeyPressedNumeric(event: any): boolean {
    const inputVal = document.getElementById('mobile') as HTMLInputElement;
    let input = inputVal.value;
    input = input + event.key;
    if (input.length >= 2) {
      const txtVal = input;
      return /^((\d{1,10}))$/.test(txtVal);
    }
    const charCode = this.getCharCode(event);
    const charStr = event.key ? event.key : String.fromCharCode(charCode);
    return this.isCharNumeric(charStr);
  }

  private getCharCode(event: any): any {
    event = event || window.event;
    return (typeof event.which === 'undefined') ? event.keyCode : event.which;
  }

  private isCharNumeric(charStr: any): boolean {
    let validation = false;

    if (charStr === '.') {
      validation = !!/\./.test(charStr);
    } else {
      validation = !!/\d/.test(charStr);
    }
    return validation;
  }

  async checkLineId(payload) {
    console.log('payload ', payload)
    const funcName = 'checkLineId';
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    this.verifyCustomerService.apiVerifyLineID(payload).subscribe(
      result => {
        this.logger.info(`${this.log_session_text} ${funcName} result response`);
        console.log('result of verify line: ', result);
        const register = this.lineStateAction.customerStateInfo;
        const identity = this.lineStateAction.identityStateInfo;
        const channel = this.lineStateAction.channelStateInfo;
        console.log(identity);
        const data = {
          ...register,
          ...channel,
          ...identity,
          update_channel_identity_flag: true
        };


        // const json_res = JSON.stringify(result);
        // alert(json_res);
        if (result) {
          this.logger.info(`${this.log_session_text} ${funcName} result.state_code:${result?.state_code}`);
          switch (result.state_code) {
            case (ResponseStateLineID.EX_LINE_ID): {
              data.update_channel_identity_flag = false;
              const params = {
                update_channel_identity_flag: false
              };
              this.logger.info(`${this.log_session_text} ${funcName} ex_line_id goto confirm-otp params:${JSON.stringify(params)}`);
              this.redirectConfirmOTP(params);
              // this.register(data);
              break;
            }
            case (ResponseStateLineID.NEW_LINE_ID): {
              // ไลน์ไอดีใหม่
              this.logger.info(`${this.log_session_text} ${funcName} new_line_id goto confirm-otp`);
              this.router.navigate(['../line-confirm'], { relativeTo: this.route });
              break;
            }
            default: {

            }
          }
        } else {
          this.logger.info(`${this.log_session_text} ${funcName} result response is null`);
          this.invalidInformation = true;
          // this.router.navigate(['../mobile-verify'], { relativeTo: this.route });
          this.modalService.open(LineModalTemplateComponent, this.lineModalService.setModalConfig('alert', 'ไม่สามารถทำรายการได้', ['เกิดข้อผิดพลาด', 'กรุณาลองใหม่อีกครั้ง'])).onResult().subscribe(
            closed => console.log('closed', closed),
            dismissed => console.log('dismissed', dismissed),
            () => console.log('.')
          );
        }

        // console.log(result);
      }
    );
  }

  private redirectConfirmOTP(param: any = null) {
    const funcName = 'redirectConfirmOTP';
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    let params = {};
    if (this.type == "notmatch") {
      params = {
        notmatch: true
      }
      this.logger.info(`${this.log_session_text} ${funcName} case notmatch`);
    } else {
      this.logger.info(`${this.log_session_text} ${funcName} case other`);
      const register = this.lineStateAction.customerStateInfo;
      const identity = this.lineStateAction.identityStateInfo;
      const channel = this.lineStateAction.channelStateInfo;
      params = {
        idcard: identity.id_card,
        mobile: identity.phone_number,
        // lineId: channel.channel_identity,
        more: param
      }
      this.logger.fin(`${this.log_session_text} ${funcName} case other goto page confirm-otp`);
    }

    const query = encryptData(this.b64EncodeUnicode(JSON.stringify(params)));
    this.router.navigate(['../confirm-otp'], { relativeTo: this.route, queryParams: { params: query } });
  }

  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    }))
  }

  onSubmit() {
    const funcName = 'onSubmit';
    console.log(this.model().form);
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const identity = this.lineStateAction.identityStateInfo;
    const payload: VerifyIdentity = {
      id_card: identity.id_card,
      phone_number: this.model().form.mobile.value,
      update_chanel_identity_flag: false,
      electronic_channel : this.lineStateAction.channelStateInfo.electronic_channel
    }
    const log_payload = {
      ...payload,
      id_card: this.getMaskingService.maskingData(payload.id_card),
      phone_number: this.getMaskingService.maskingData(payload.phone_number),
    }
    this.logger.info(`${this.log_session_text} ${funcName} payload:${JSON.stringify(log_payload)}`);
    this.lineActionService.sinkIdentity.next(new SetIdentityAction(payload));
    //console.log(payload);
    {
      this.verifyCustomerService.apiVerityCuestomer(payload).subscribe(
        result => {
          //console.log("result of responses: ", result);
          this.loaderService.closeLoader();
          this.logger.info(`${this.log_session_text} ${funcName} result response`);
          if (!result) return
          //console.log(result);
          this.logger.info(`${this.log_session_text} ${funcName} result state_code:${result?.state_code}`);
          switch (result.state_code) {
            case (ResponseCodeVerifyCustomer.SUCCESS): {
              if (this.type == "notmatch") {
                const params = {
                  notmatch: true
                };
                this.logger.info(`${this.log_session_text} ${funcName} notmatch goto confirm-otp params:${JSON.stringify(params)}`);
                this.redirectConfirmOTP(params);
              } else {
                this.lineStateAction.sinkIdentity.next(new SetIdentityAction(identity));
                const customer: Customer = {
                  "firstname": result.data.firstname,
                  "lastname": result.data.lastname,
                  "new_plateform_customer_flag": result.data.new_plateform_customer_flag
                }
                this.logger.info(`${this.log_session_text} ${funcName} case other`);
                this.lineStateAction.sinkCustomer.next(new SetCustomerAction(customer));
                const channel = this.lineStateAction.channelStateInfo;

                const verifyLineData: VerifyLineID = {
                  ...identity,
                  ...customer,
                  ...channel
                };
                console.log('line registration: ', verifyLineData);
                this.logger.info(`${this.log_session_text} ${funcName} case other checkLineId`);
                this.checkLineId(verifyLineData);
              }

              break;
            }
            case (ResponseCodeVerifyCustomer.NOTFOUND_IDCARD): {
              this.logger.info(`${this.log_session_text} ${funcName} case notfound_idcard`);
              break;
            }
            case (ResponseCodeVerifyCustomer.NOTFOUND_PHONE): {
              this.logger.info(`${this.log_session_text} ${funcName} case notfound_phone`);
              this.invalidInformation = true;
              this.inValidPhoneCount++;
              if (this.inValidPhoneCount == 5) {
                this.logger.info(`${this.log_session_text} ${funcName} case notfound_phone inValidPhoneCount==5`);

                this.modalService.open(LineModalTemplateComponent, this.lineModalService.setModalConfig('alert', 'ไม่สามารถทำรายการได้', ['ท่านใส่ข้อมูลผิดเกินจำนวนครั้งที่กำหนด', 'กรุณาติดต่อเจ้าหน้าที่'])).onResult().subscribe(
                  closed => {
                    console.log('closed', closed);
                    try {
                      liff.closeWindow();
                    } catch (err) {

                    }
                  },
                  dismissed => {
                    console.log('dismissed', dismissed);
                    try {
                      liff.closeWindow();
                    } catch (err) {

                    }
                  },
                  () => {
                    console.log('.');
                    try {
                      liff.closeWindow();
                    } catch (err) {

                    }
                  }
                );
              } else {
                this.logger.info(`${this.log_session_text} ${funcName} case notfound_phone inValidPhoneCount other`);
                this.modalService.open(LineModalTemplateComponent, this.lineModalService.setModalConfig('alert', 'ไม่สามารถทำรายการได้', ['ข้อมูลของท่านไม่ตรงกับในระบบ', 'กรุณากรอกใหม่อีกครั้ง'])).onResult().subscribe(
                  closed => {
                    const current = structuredClone(this.model());
                    current.form.mobile.value = "";
                    this.model.set(current)
                    console.log('closed', closed);
                  },
                  dismissed => {
                    const current = structuredClone(this.model());
                    current.form.mobile.value = "";
                    this.model.set(current)
                    console.log('dismissed', dismissed);
                  },
                  () => {
                    const current = structuredClone(this.model());
                    current.form.mobile.value = "";
                    this.model.set(current)
                    console.log('.');
                  }
                );
              }
              // this.router.navigate(['../mobile-verify'], { relativeTo: this.route });

              break;
            }
            case (ResponseCodeVerifyCustomer.PHONE_NOT_MATCH): {
              console.log("phone not match");
              this.logger.info(`${this.log_session_text} ${funcName} case phone_not_match`);
              break;
            }
          }
        }
      )
    }

    // this.router.navigate(['../mobile-list'], { relativeTo: this.route })
  }

}
